module.exports = __webpack_public_path__ + "img/shangjia2.3de2e5b7.png";